<template>
    <aside class="layout-sidebar text-sm" :class="{ active: active }">
        <nav>
            <ol class="layout-menu">
                <AppMenuItem :menu="items"></AppMenuItem>
            </ol>
        </nav>
    </aside>
</template>

<script>

export default {
    props: {
        active: {
            type: Boolean,
            default: true
        },
        items: {
            type: Array
        }
    },
};
</script>
